<template>
  <stage-card
    class="screening-progress-card"
    always-show-content-and-actions
  >
    <template #header>
      Title &amp; Abstract Screening Progress
    </template>
    <template #progress-chip>
      <!-- Progress text & bar -->
      <div class="progress">
        <!-- Progress text -->
        <div class="progress-text">
          {{ progressFractionText }}
          <div class="pct">{{ progressPercentageText }}</div>
        </div>

        <!-- Progress bar -->
        <screening-progress-breakdown
          class="progress-bar"
          :review="review"
          hide-legend
        />
      </div>
    </template>
    <template #content>
      <!-- First column (what has been done so far) -->
      <div class="content-col">
        <!-- Results -->
        <screening-results-semi-circle :review="review" />

        <!-- Trend -->
        <stopping-criteria-metrics :review="review" />

        <!-- Relevance Ranking AI -->
        <relevance-ranking-status :review="review" />
      </div>

      <!-- Second column (what potentially remains) -->
      <div class="content-col">
        <!-- Forecast -->
        <screening-forecast :review="review" />

        <!-- Relevance Distribution -->
        <relevance-distribution :review="review" />
      </div>

      <!-- Third column (what the user can do) -->
      <div class="content-col">
        <!-- Screening Tasks -->
        <screening-tasks :review="review" />

        <!-- Recommendation -->
        <screening-recommendation :review="review" />
      </div>
    </template>
    <template #actions>
      <screening-progress-card-actions
        :review="review"
        :current-researcher="currentResearcher"
      />
    </template>
  </stage-card>
</template>

<script>
import StageCard from '@/components/DashboardTab/StageCard';
import ScreeningProgressBreakdown from '@/components/ReviewSummary/ScreeningProgressBreakdown';
import ScreeningResultsSemiCircle from './ScreeningResultsSemiCircle';
import StoppingCriteriaMetrics from './StoppingCriteriaMetrics';
import RelevanceRankingStatus from './RelevanceRankingStatus';
import ScreeningForecast from './ScreeningForecast';
import RelevanceDistribution from './RelevanceDistribution';
import ScreeningTasks from './ScreeningTasks';
import ScreeningRecommendation from './ScreeningRecommendation';
import ScreeningProgressCardActions from './ScreeningProgressCardActions';
import { Review, Researcher } from '@/models';

export default {
  name: 'ScreeningProgressCard',
  components: {
    StageCard,
    ScreeningProgressBreakdown,
    ScreeningResultsSemiCircle,
    StoppingCriteriaMetrics,
    RelevanceRankingStatus,
    ScreeningForecast,
    RelevanceDistribution,
    ScreeningTasks,
    ScreeningRecommendation,
    ScreeningProgressCardActions,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
    currentResearcher: {
      type: Researcher,
      required: true,
    },
  },
  computed: {
    progressFractionText() {
      return `${this.progressCount.toLocaleString()} / ${this.totalCount.toLocaleString()}`;
    },
    progressPercentageText() {
      const pct = (this.progressCount / this.totalCount) * 100;
      return `(${pct.toFixed(0)}%)`;
    },
    progressCount() {
      const { screeningProgressSummary } = this.review;
      return screeningProgressSummary.screenedCount;
    },
    totalCount() {
      const { screeningProgressSummary } = this.review;
      return screeningProgressSummary.totalReferenceCount();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/main.sass';

.screening-progress-card {
  .progress {
    @extend .d-flex, .align-center;
    gap: 16px;
  }

  .progress-bar {
    width: 250px;
  }

  .progress-text {
    @extend .d-flex, .align-center;
    gap: 4px;

    font-size: 14px;
    font-weight: 500;

    .pct {
      @extend .grey--text, .text--lighten-1;
    }
  }

  .content-col {
    @extend .d-flex, .flex-column;
    gap: 32px;
  }
}
</style>
